
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevModal } from '@ds/components/Modal'
import { RevTag } from '@ds/components/Tag'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { trackClick } from '@tracking/events'

import translations from './PrepaidPlanModal.translations'

export default {
  components: {
    FormattedMessage,
    IconCheckInCircle,
    RevButton,
    RevIllustration,
    RevLink,
    RevModal,
    RevTag,
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.PREPAID_PLAN,
    translations: () => translations,
  },
  methods: {
    trackButtonClick() {
      trackClick({
        name: 'talk_US_mobile',
        page_type: this.$route.name,
        zone: 'mobile_plan',
      })
    },
  },
}
